const baseUrl = 'https://blooming-meadow-49781.herokuapp.com/api/v1';

export default baseUrl;
